import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/",
    },
    {
      path: "/",
      name: "PageView",
      component: (resolve) => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home",
        },
        {
          path: "/home",
          name: "home",
          component: (resolve) => require(["@/view/HomePage"], resolve),
          meta: {
            title: "首页",
          },
        },
        {
          path: "/",
          name: "fox",
          component: (resolve) => require(["@/view/fox"], resolve),
          meta: {
            title: "狐锂智能",
          },
          children: [
            {
              path: "/fox/Replacethebattery",
              name: "Replacethebattery",
              component: (resolve) =>
                require(["@/view/Replacethebattery"], resolve),
              meta: {
                title: "狐锂换电",
              },
            },
            {
              path: "/fox/CarRental",
              name: "CarRental",
              component: (resolve) => require(["@/view/CarRental"], resolve),
              meta: {
                title: "狐锂租车",
              },
            },
            {
              path: "/fox/shop",
              name: "shop",
              component: (resolve) => require(["@/view/shop"], resolve),
              meta: {
                title: "千城万店",
              },
            },
          ],
        },
        {
          path: "/software/smartTown",
          name: "software",
          component: (resolve) => require(["@/view/Software"], resolve),
          meta: {
            title: "项目研发",
          },
          children: [
            {
              path: "/software",
              redirect: "/software/smartTown",
            },
            {
              path: "/software/smartTown",
              name: "software",
              component: (resolve) =>
                require(["@/view/Software_smartTown"], resolve),
              meta: {
                title: "充电桩系统",
              },
            },
            {
              path: "/software/bigData",
              name: "bigData",
              component: (resolve) =>
                require(["@/view/Software_bigData"], resolve),
              meta: {
                title: "租车系统",
              },
            },
            {
              path: "/software/Chargingcabinetsystem",
              name: "Chargingcabinetsystem",
              component: (resolve) =>
                require(["@/view/Chargingcabinetsystem"], resolve),
              meta: {
                title: "充电柜系统",
              },
            },
            {
              path: "/software/Batteryexchange",
              name: "Batteryexchange",
              component: (resolve) =>
                require(["@/view/Batteryexchange"], resolve),
              meta: {
                title: "换电柜系统",
              },
            },
          ],
        },
        {
          path: "/Service",
          name: "Service",
          component: (resolve) => require(["../view/Service"], resolve),
          meta: {
            title: "相关服务",
          },
        },
        {
          path: "/newsinformation",
          name: "newsinformation",
          component: (resolve) => require(["@/view/NewsInformation"], resolve),
          meta: {
            title: "新闻动态",
          },
        },
        {
          path: "/",
          name: "adboutUs",
          component: (resolve) =>
            require(["@/view/adboutUs"], resolve),
          meta: {
            title: "关于我们",
          },
          children:[
            {
              path: "/adboutUs/CompanyIntroduction",
              name: "CompanyIntroduction",
              component: (resolve) =>
                require(["@/view/CompanyIntroduction"], resolve),
              meta: {
                title: "关于我们",
              },
            },
            {
              path: "/adboutUs/honor",
              name: "honor",
              component: (resolve) =>
                require(["@/view/honor"], resolve),
              meta: {
                title: "荣誉资质",
              },
            },{
              path: "/adboutUs/aboutsPeixun",
              name: "aboutsPeixun",
              component: (resolve) =>
                require(["@/view/aboutsPeixun"], resolve),
              meta: {
                title: "学员培训",
              },
            },
          ]
        },
        // {
        //   path: "/jobchance",
        //   name: "jobchance",
        //   component: (resolve) => require(["@/view/JobChance"], resolve),
        //   meta: {
        //     title: "工作机会",
        //   },
        // },
        {
          path: "/contactus",
          name: "contactus",
          component: (resolve) => require(["@/view/ContactUs"], resolve),
          meta: {
            title: "联系我们",
          },
        },
        {
          path: "/servicedetail",
          name: "servicedetail",
          component: (resolve) => require(["@/view/ServiceDetail"], resolve),
          meta: {
            title: "相关服务",
          },
        },
      ],
    },
  ],


  //进入页面时回到最顶部
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的滚动位置，返回该位置
    if (savedPosition) {
      return savedPosition;
    } else {
      // 否则返回顶部
      return { x: 0, y: 0 };
    }
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js